// @flow

import ApiClient from 'utils/ApiClient';
import CurrentUserAction from 'actions/CurrentUserActions';
import Dispatcher from 'dispatcher';
import * as CurrentUserActionType from 'action_types/CurrentUserActionTypes';

class NotifyConfirmationActions {
  setEmailConfirmation(
    userid: string,
    email: string,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.post({
      path: `/users/${userid}/sign_up_verifications`,
      jsonData: {
        account_type: 'email',
        value: `${email}`
      },
      success,
      error
    });
  }

  sendCodeWhatsapp(
    userid: string,
    phone: string,
    kindWA: string,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.post({
      path: `/users/${userid}/sign_up_verifications`,
      jsonData: {
        account_type: 'whatsapp',
        value: `${phone.replace('+', '')}`,
        requested_from: kindWA
      },
      success: () => {
        Dispatcher.dispatch({
          type: CurrentUserActionType.SET_LAST_CODE_DATE,
          data: new Date().toISOString()
        });
        if (success) {
          success();
        }
      },
      error
    });
  }

  verifyCodeWhatsapp(
    userid: string,
    token: string,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.put({
      path: `/users/${userid}/sign_up_verifications/whatsapp`,
      jsonData: {
        token: `${token}`
      },
      success: () => {
        CurrentUserAction.getCurrent(() => {
          success();
        });
      },
      error
    });
  }

  emailConfirmationVerifier(
    user_id: string,
    success?: () => void,
    error?: () => void
  ) {
    return ApiClient.get({
      path: `/users/${user_id}/email_verified.json`,
      success: response => {
        if (response.user.email_verified) {
          CurrentUserAction.getCurrent();
        }
        success();
      },
      error
    });
  }

  updateMobilePhone(
    userId,
    data: {},
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.put({
      path: `/v1/users/${userId}`,
      jsonData: data,
      skipRedirect: true,
      success: () => {
        CurrentUserAction.getCurrent(() => {
          success && success();
        });
      },
      error: error
    });
  }
}

export default new NotifyConfirmationActions();
